import React from 'react';

export default function UploadProgressModal({ durum }) {
  if (!durum?.aktif) return null;
  const progress = Number.isFinite(Number(durum.progress)) ? Math.max(0, Math.min(100, Number(durum.progress))) : 0;
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(6, 12, 20, .45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 12000,
        padding: 16,
      }}
    >
      <div
        style={{
          width: 'min(92vw, 460px)',
          background: 'var(--surface)',
          border: '1px solid var(--border2)',
          borderRadius: 10,
          boxShadow: '0 18px 52px rgba(0,0,0,.35)',
          padding: '18px 16px',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center', marginBottom: 10 }}>
          <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 12, fontWeight: 800, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--blue)' }}>
            {durum.baslik || 'Yükleniyor'}
          </div>
          <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 24, fontWeight: 900, color: 'var(--blue)' }}>
            %{progress}
          </div>
        </div>
        <div style={{ height: 10, borderRadius: 999, overflow: 'hidden', background: 'rgba(41,128,185,.14)', marginBottom: 10 }}>
          <div style={{ width: `${progress}%`, height: '100%', background: 'var(--blue)', transition: 'width .2s ease' }} />
        </div>
        <div style={{ fontSize: 12, color: 'var(--ink2)' }}>{durum.detay || 'Dosya hazırlanıyor...'}</div>
      </div>
    </div>
  );
}
